<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">Quản lý đơn vị</div>
      </div>
      <div class="card card-w-title" v-if="checkVisible('organization', 'import')">
        <div class="box-title">Import đơn vị</div>
        <div class="import-data">
          <!-- <button class="download-file" @click="downloadFile">
            <i class="pi pi-download"></i>Tải mẫu file import
          </button> -->
          <div class="box-form-import">
            <!-- <InputText readonly="true" id="filename" type="text" v-model="filename" /> -->
            <Button :disabled="files.length > 0" :label="'Chọn file'" @click="openFile" :class="(files.length > 0 ? ' disabled ' : '') + 'item-inline-import'"/>
            <input id="files" ref="files" type="file" style="display:none" @change="chooseFile"/>
            <div :class="'item-inline-import middle-inline' + (files.length > 0 ? '' : ' normal')">
              <label :class="files.length > 0 ? '' : 'normal'">{{filename}}</label>
              <a @click="removeFile" v-if="files.length > 0" >Xoá</a>
            </div>
            <Button :disabled="files.length == 0" :class="(files.length > 0 ? '' : 'background-none') + ' disabled-opacity item-inline-import'" :label="'Import'"  @click="importData" />
          </div>
          <div class="download-file">
            <span class="class-span">Tải mẫu file import</span> <a @click="downloadFile">Tại đây <i class="pi pi-download"></i></a>
          </div>
        </div>
      </div>
      <div class="card card-w-title">
        <div class="list-data">
          <div class="p-grid">
            <div class="p-col-6" v-if="$myConstants.checkRoleGroup('organization', 'download')">
              <div class="import-data-custom download-data-custom">
                <button class="download-file-custom" @click="exportDataExcelFile" >
                  <i class="pi pi-download"></i>Xuất dữ liệu
                </button>
                <span >(Danh sách đơn vị được tải về theo điều kiện lọc đã nhập)</span>
              </div>
            </div>
            <div class="p-col-6">
              <div :class="'box-info-account '+($myConstants.checkRoleGroup('organization', 'download') == true ? 'text-right':'text-left') ">
                <span>Số lượng đơn vị cấp con đã tạo: <b :class="(total_child.count >= total_child.total) ? 'error':''">{{ total_child.count }}/{{ total_child.total }} đơn vị</b></span>
              </div>
            </div>
          </div>

          <div class="list-title">
            <span class="p-m-0">Danh sách đơn vị</span>
            <span class="p-input-icon-left" v-if="checkVisible('organization', 'add')">
              <Button
              :label="'Tạo mới'"
                type="button"
                v-on:click="onActionClicked({action: {name: 'add', label: 'Tạo mới', path: `admin/organization/add`}, key: 'add'})"
              > </Button>
            </span>
          </div>
          <BaseCommon v-if="dataModel"
            :key="componentKey"
            :listData="listData"
            :model="dataModel"
            :filterDefault="filters"
            @filter="filterData"
            :actions="getRowActions()"
            :globalFilterFields="globalFilterFields"
            :columnsDisplays="columnsDisplays"
            v-on:action-click="onActionClicked"
            @callback="callback"
            @clearFilter="cancelFilter"
          ></BaseCommon>
        </div>
      </div>
    </div>
    <PopupMessage :key="importComponentKey" :popup_type="'organization'"  @export-excel="exportDataExcel"  :messages="messages" :displayDialog="displayDialog" @accept="acceptImport" @cancel="cancelImport"/>
    <Dialog
        class="dialog-comfirm-common"
        :visible.sync="showConfirmDialog"
        :contentStyle="{overflow: 'visible'}"
        :modal="true"
        :closable="true"
    >
      <div class="box_body_popup" >
        <div v-if="creenConfirmDialog == 'export_success'">
          <div class="box_title_suceess"><img class="img_noti" :src="check_success_img" /><span class="title_noti" style="">Thành công</span></div>
          <p class="p_title_1" style="text-align: left"><span style="font-weight: 700">Danh sách đơn vị</span> đã xuất dữ liệu thành công. Vui lòng thực hiện tải về tại module Lịch sử xuất dữ liệu.</p>
          <div class="box_btn">
            <Button
                icon="pi pi-chevron-circle-right"
                iconPos="right"
                class="btn-custom"
                :label="'Lịch sử xuất dữ liệu'"
                type="button"
                @click="redirect_ToHistory"
            > </Button>
          </div>
        </div>
        <div v-if="creenConfirmDialog == 'export_err'">
          <div class="box_title_err"><img class="img_noti" :src="err_massage_img" /><span class="title_noti" style="">Thất bại</span></div>
          <p class="p_title_1" style="text-align: left">Quá trình xuất dữ liệu <span style="font-weight: 700;">Danh sách đơn vị</span> đã xảy ra vấn đề. Bạn vui lòng thực hiện lại thao tác xuất dữ liệu.</p>
        </div>
      </div>
      <template #header>
        <div>
          <span class="title-confirm" >Thông báo</span>
          <!--<span class="description-confirm">asdasdas</span>-->
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import axios from 'axios'
import DataServices from '@/core/DataServices'
import BaseCommon from '../common'
import XLSX from 'xlsx'
import Api from '@/services'
import moment from 'moment'
import PopupMessage from '../common/popupMessage'
export default {
  components: {
    BaseCommon,
    PopupMessage
  },
  data() {
    return {
      urlFile: window.location.origin + '/upload/files/Template_import_co_cau_to_chuc.xlsx',
      filters: {},
      listData: [],
      dataModel: null,
      componentKey: 0,
      filename: 'Không có file đang chọn',
      optionsStatus: [],
      optionsCategories: [],
      name: '',
      code: '',
      categories_value: 0,
      status_value: 0,
      files: [],
      globalFilterFields: [],
      fileInputData: '',
      parse_header: [],
      parse_key: ["STT","Tên đơn vị*","Mã số thuế","Số điện thoại*","Email","Tỉnh/thành phố","Quận/huyện","Phường/xã","Địa chỉ","Loại đơn vị*","Số lượng đơn vị cấp con","Số lượng tài khoản", "Loại quan hệ*","Trạng thái hoạt động*","Kinh độ","Vĩ độ"],
      errorsLists: [],
      displayDialog: false,
      importComponentKey: 0,
      messages: {},
      exportData: [],
      columnsDisplays: [],
      seconds: 7,
      hardcodeID: 0,
      isManagementLevel: false,
      total_child:{
        total:0,//Tổng số đơn vị dc tạo
        count:0,//tồng số cấp con đã tạo
      },
      listDataExport:[],
      creenConfirmDialog:'export_success',
      check_success_img: window.origin + '/assets/images/check_success.png',
      err_massage_img: window.origin + '/assets/images/err_massage.png',
      showConfirmDialog:false,
      userID : null,
    }
  },
  mounted () {
    this.initData();
    if(this.$store.getters.fullname !== undefined && this.$store.getters.fullname !== null){
      if(this.$store.getters.fullname.id !== undefined && this.$store.getters.fullname.id !== null && this.$store.getters.fullname.id !== ''){
        this.userID = this.$store.getters.fullname.id
      }
    }
  },
  created () {
    if(this.$route.params.reload) {
      window.location.reload();
    }
  },
  watch: {
    '$route': 'initData'
  },
  methods: {
    initData() {
      setTimeout(async () => {
        if (!this.checkVisible('warranty_activation', 'list')) {
          this.columnsDisplays.push('list_activation')
        }
        if (this.checkVisible('organization', 'list')) {
          await this.settingsHardCode();
          await this.getSettings();
          await this.initParams();
        }
      }, 1000);
    },
    checkVisible(groupName, action) {
      return this.$myConstants.checkVisible(this.$store.getters.permission, groupName, action);
    },
    callback(col, payload) {
      if (col.name == 'list_activation') {
        if (this.checkVisible('warranty_activation', 'list')) {
          this.$router.push({name: 'warranty_activation', params: {organization_id: payload.id}});
        }
      }
      else if (col.name == 'list_warranty') {
        this.$toast.add({ severity: 'warn', summary: 'Thông báo', detail: 'Đang xây dựng', life: 3000 })
      }
      else if (col.name == "number_of_accounts") {
        if (this.checkVisible('users', 'list')) {
          this.$router.push({name: 'users', params: {organization_name: payload.name}});
        }
      }
    },
    async getSettings() {
      var variables = {
        where_key: {
          key: {'_in': ['TIME_PROCESSING_IMPORT_SECONDS'] }
        }
      }
      var data = await DataServices.getList('settings', {"variables": JSON.stringify(variables), 'fields' : 'value'});
      if (data != undefined && data != null) {
        var list = data[Object.keys(data)];
        if (Object.keys(list).length > 0) {
          this.seconds = parseInt(list[0].value);
        }
      }
    },
    async settingsHardCode() {
      var whereKey = {
        key: {'_eq': 'ORGANIZATION_ROOT' }
      }
      var variables = {
        where_key: whereKey
      }
      var data = await DataServices.getList('settings', {"variables": JSON.stringify(variables), "fields": "value"});
      var list = data[Object.keys(data)];
      if (list !== undefined && list !== null && Object.keys(list).length) {
        this.hardcodeID = list[0].value;
      }
    },
    async initParams() {
      this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      var vm = this;
      //get total đơn vị cấp con
      var organizationIDParent = null;
      var organizationLogin = this.$myConstants.organizationUserLogin();
      var creator_organization_id = (!this.$myConstants.isEmpty(organizationLogin.id)) ? organizationLogin.id:null;
      if (organizationLogin && Object.keys(organizationLogin).length) {
        organizationIDParent = organizationLogin.id;
        this.total_child.total = (!this.$myConstants.isEmpty(organizationLogin.number_of_subunits)) ? organizationLogin.number_of_subunits:0;
      }

      this.modelName = 'organization';
      this.isManagementLevel = this.$myConstants.managementLevel();
      
      var whereKey = {
        status: {'_in': [0, 1] }
      }


      /*var showAll = false;
      if (this.$store.getters.fullname != undefined && this.$store.getters.fullname != null && this.$store.getters.fullname.user_type == 3) { 
        showAll = true;
      } else if (this.$store.getters.fullname.user_type == 2) {
        //check quản lý dữ liệu đơn vị
        if (!this.isManagementLevel) showAll = false;
        else {
          if (this.$store.getters.fullname != undefined && this.$store.getters.fullname != null && 
          this.$store.getters.fullname.organization_account != undefined && this.$store.getters.fullname.organization_account != null &&
          this.$store.getters.fullname.organization_account.organization_id != undefined && this.$store.getters.fullname.organization_account.organization_id != null && this.$store.getters.fullname.organization_account.organization_id > 0) {
            var organizationID = this.$store.getters.fullname.organization_account.organization_id;
            // nếu khác đơn vị gốc
            if (organizationID != this.hardcodeID) {
              showAll = true;
              whereKey = Object.assign(whereKey, {parent_id: {'_eq': organizationID}});
            } else {
              //nếu không có cấp trên
              showAll = (this.$myConstants.levelParent() == 0);
            }
          }
        }
      }*/
      //Phân quyền dữ liệu
      var is_management_units = false;
      if (parseFloat(this.hardcodeID) ==  creator_organization_id){
        if (!this.$myConstants.isEmpty(this.$store.getters.fullname.is_management_units)){
          if (this.$store.getters.fullname.is_management_units == true){
            is_management_units = true;
          }
        }
      }
      if (is_management_units == false){
        whereKey = Object.assign(whereKey, {parent_id: {'_eq': creator_organization_id}});
      }
      //if(!showAll) this.listData = [];
      var variables = {
        where_key: whereKey,
        orderBy: {
          //modified_date: 'desc_nulls_last',
          id: 'desc'
        }
      }

      //Count tổng số đơn vị cấp con đã dc tạo
      if (!this.$myConstants.isEmpty(organizationIDParent)){
        var whereKeyCount = this.$myConstants.convertJsonObject(whereKey);
        whereKeyCount = Object.assign(whereKeyCount, {parent_id: {'_eq': organizationIDParent}});
        whereKeyCount = Object.assign(whereKeyCount, {status: {'_in': [ 1] }});//chỉ lấy trạng thái đang hoạt động
        var variablesCount = {
          where_key: whereKeyCount
        }
        DataServices.countData(this.modelName, {"variables": JSON.stringify(variablesCount)}).then(async (countDataQuery) => {
          var countOrganization = countDataQuery['core_organization_aggregate']['aggregate']['count'];
          if (!vm.$myConstants.isEmpty(countOrganization)){
            vm.total_child.count = countOrganization;

          }
        })
      }


      var data = await DataServices.getList(this.modelName, {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];
      this.dataModel = DataServices.getModel(this.modelName);
      this.dataModel.processData(list);
      this.listDataExport = list;
      this.listData = list;
      this.componentKey++;
      await this.settingUnit();
      this.$store.commit('setLoading', false);
    },
    async settingUnit() {
      var variables = {
        where_key: {
          status: {'_in': [0,1] }
        },
        orderBy: {
          created_date: 'desc',
          modified_date: 'desc'
        }
      }
      var data = await DataServices.getList('setting_unit', {"variables": JSON.stringify(variables), "fields": "id,name"});
      this.optionsCategories.push({label: "Tất cả", value: 0});
      var list = data[Object.keys(data)];
      if (list !== undefined && list !== null && Object.keys(list).length) {
        for (let index = 0; index < list.length; index++) {
          const item = list[index];
          this.optionsCategories.push({label: item.name, value: item.id});
        }
      }
    },
    onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      switch (action.name) {
        case 'add':
          if (this.checkVisible('organization', 'add')) {
            this.$router.push({path: '/admin/organization/function'});
          }
          break;
        case 'edit':
          if (this.checkVisible('organization', 'edit')) {
            if (data && Object.keys(data).length) {
              this.$router.push({path: '/admin/organization/function/' + data.data.id});
            }
          }
          break;
      }
    },
    getRowActions() {
      var actions = {}
      var that = this;
      actions.filter = { name: 'clear', icon: 'times-circle'};
      actions.rows = function (rowData) {
        var buttons = {}
        if (that.checkVisible('organization', 'edit')) {
          buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `admin/organization/edit`}
          if (that.dataModel.actions) {
            var modelaction = that.dataModel.actions(rowData)
            Object.assign(buttons, modelaction);
          }
        }
        return buttons
      }
      return actions
    },
    cancelFilter() {
      this.filters = {};
      // this.componentKey++;
      this.listDataExport = this.listData;
    },
    async cancelImport() {
      var params = {};
      params = Object.assign(params, { 'status': 6 });
      params = Object.assign(params, { 'modified_date': this.$myConstants.currentDate() });
      var result = await DataServices.updateData('import_data_processing', {"variables": JSON.stringify({data_update: params, where_key: { id: {'_eq': this.importID }}})});
      if (result != null) {
        var checkUpdate = result[Object.keys(result)];
        if (checkUpdate.affected_rows) this.displayDialog = false;
      } else this.displayDialog = false;
      this.importComponentKey = Math.random()*350;
      this.files = [];
      this.filename = 'Không có file đang chọn';
      document.getElementById('files').value = null;
    },
    async acceptImport() {
      var params = {};
      params = Object.assign(params, { 'status': 5 });
      params = Object.assign(params, { 'modified_date': this.$myConstants.currentDate() });
      var result = await DataServices.updateData('import_data_processing', {"variables": JSON.stringify({data_update: params, where_key: { id: {'_eq': this.importID }}})});
      if (result != null) {
        var checkUpdate = result[Object.keys(result)];
        if (checkUpdate.affected_rows) this.displayDialog = false;
      } else this.displayDialog = false;
      this.importComponentKey = Math.random()*380;
      this.$store.commit('setDataLoading', {content: 'Đang import dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      this.waittingImport();
    },
    downloadFile() {
      var filename = this.$myConstants.getFileName(this.urlFile);
      axios({
        url: this.urlFile,
        method: 'GET',
        responseType: 'blob',
        }).then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', filename);
          document.body.appendChild(fileLink);
          fileLink.click();
      });
    },
    openFile() {
      this.$refs.files.click();
    },
    removeFile() {
      this.files = [];
      document.getElementById("files").value = null;
      this.filename = 'Không có file đang chọn';
    },
    chooseFile($event) {
      $event.preventDefault();
      var fileSelects = $event.target.files || $event.dataTransfer.files;
      if (!fileSelects.length)
        return;
      var file = fileSelects[0].name;
      var extension = this.$myConstants.getFileExtension(file);
      this.files = [];
      if (['xlsx', 'xls'].includes(extension)) {
        this.files.push(fileSelects);
        this.filename = file;
      } else {
        this.files = [];
        this.filename = 'Không có file đang chọn';
        this.errorsText = 'Import thất bại do sai template';
        document.getElementById("files").value = null;
        this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: this.errorsText, life: 3000 })
      }
    },
    importData() {
      if (this.files.length > 0) {
        this.$store.commit('setDataLoading', {content: 'Đang kiểm tra file import', icon: true});
        this.$store.commit('setLoading', true);
        var vm = this;
        var file = this.$refs.files.files[0];
        var reader = new FileReader();
        reader.onload = function(e) {
          var data = e.target.result, 
          fixedData = vm.fixedData(data), 
          workbook = XLSX.read(btoa(fixedData), {type: 'base64'}), 
          firstSheetName = workbook.SheetNames[0],
          worksheet = workbook.Sheets[firstSheetName];
          vm.fileInputData = worksheet;
          if (firstSheetName != 'Danh_sach_import') {
            vm.files = [];
            vm.filename = 'Không có file đang chọn';
            document.getElementById("files").value = null;
            vm.$store.commit('setLoading', false);
            vm.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Import thất bại do sai template', life: 3000 })
          } else {
            vm.processImport(file, vm.fileInputData);
          }
        };
        reader.readAsArrayBuffer(file);
      }
    },
    getHeaderRow(sheet) {
      var headers = [], range = XLSX.utils.decode_range(sheet['!ref']);
      var C, R = range.s.r; /* start in the first row */
      for(C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
          var cell = sheet[XLSX.utils.encode_cell({c:C, r:R})] /* find the cell in the first row */
          if (cell !== undefined) {
            var hdr = "UNKNOWN " + C; // <-- replace with your desired default 
            if(cell && cell.t) hdr = XLSX.utils.format_cell(cell);
            headers.push(hdr);
          }
      }
      return headers;
    },
    fixedData(data) {
      var o = "", l = 0, w = 10240;
      for(; l<data.byteLength/w; ++l) o+=String.fromCharCode.apply(null,new Uint8Array(data.slice(l*w,l*w+w)));
      o+=String.fromCharCode.apply(null, new Uint8Array(data.slice(l*w)));
      return o;
    },
    async checkWorkSheetToJson(file, worksheet) {
      var vm = this;
      vm.parse_header = vm.getHeaderRow(worksheet);
      var headerText = vm.parse_header.join(',').toLowerCase().replace(/\s/g, '').trim();
      var parseHeader = vm.parse_key.join(',').toLowerCase().replace(/\s/g, '').trim();
      if (vm.parse_key.length < vm.parse_header.length || vm.parse_key.length > vm.parse_header.length || parseHeader != headerText) {
        this.$store.commit('setLoading', false);
        this.files = [];
        this.filename = 'Không có file đang chọn';
        document.getElementById("files").value = null;
        this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Import thất bại do sai template', life: 3000 })
      }
      else  {
        var results = XLSX.utils.sheet_to_json(worksheet);
        if (results != null && results.length != undefined && results.length > 5001) {
          this.$store.commit('setLoading', false);
          this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Dữ liệu đã vượt quá 5000 dòng, vui lòng kiểm tra lại file import', life: 3000 })
        } else {
          let formData = new FormData();
          formData.append('file', file)
          await Api.post('/common/upload-s3', formData)
          .then(async (response) => {
            await vm.addRecords(response.data);
          })
          .catch(async (error) => {
            this.$store.commit('setLoading', false);
            vm.$toast.add({ severity: 'error', summary: 'Thông báo', detail: error, life: 3000 })
          });
        }
      }
    },
    async processImport(file, worksheet) {
      await this.checkWorkSheetToJson(file, worksheet);
    },
    async addRecords(response) {
      var params = {};
      var vm = this;
      var fileName = response.data.path;
      fileName = (fileName.substring(0, 1) == '/' ? fileName.substring(1) : fileName);
      params = Object.assign(params, { 'user_id': this.$store.getters.fullname.id })
      params = Object.assign(params, { 'file_path': fileName })
      params = Object.assign(params, { 'import_type': 'organization' })
      params = Object.assign(params, { 'process_status': 1 })
      params = Object.assign(params, { 'status': 1 })
      params = Object.assign(params, { 'created_date': this.$myConstants.currentDate() });
      params = Object.assign(params, { 'modified_date': this.$myConstants.currentDate() });
      var result = await DataServices.insertData('import_data_processing', {"variables": JSON.stringify({objects: params})});
      if (result != null) {
        var checkInsert = result[Object.keys(result)];
        if (checkInsert.affected_rows && this.seconds > 0) {
          var importID = checkInsert.returning[0].id;
          vm.importID = importID;
          await vm.waittingImport();
        } else this.$store.commit('setLoading', false);
      } else this.$store.commit('setLoading', false);
    },
    waittingImport() {
      var step = 0;
      var vm = this;
      if (this.importID > 0) {
        var callData  =  window.setInterval(async () => {
          step++;
          if (step > vm.seconds) {
            step = 0;
            var stop = await vm.checkImportProcessing();
            if (stop) {
              vm.$store.commit('setLoading', false);
              clearInterval(callData);
            }
          }
        }, 1000);
      }
    },
    async checkImportProcessing() {
      var variables = {
        where_key: {
          id: {'_eq': this.importID},
          import_type: {'_eq': 'organization'}
        }
      }
      var data = await DataServices.getList('import_data_processing', {"variables": JSON.stringify(variables), "fields": "data data_errors message count_data_processing process_status status"});
      var list = data[Object.keys(data)];
      if (list !== undefined && list !== null && Object.keys(list).length) {
        var result = list[0];
        this.messages = result.message;
        this.exportData = result.data;
        // lỗi import
        if (result.process_status == 4) {
          this.displayDialog = true;
          this.importComponentKey = Math.random()*2000;
          return true;
        } else if (result.process_status == 3) {
          this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Import thành công', life: 3000 })
          this.$store.commit('setLoading', false);
          setTimeout(() => {
            window.location.reload();
          }, 2000);
          return true;
        } else if (result.status == 4 || result.status == 3) {
          this.displayDialog = true;
          this.importComponentKey = Math.random()*300;
          return true;
        }
        return false;
      }
      return true;
    },
    async  exportDataExcelFile(){
      var list_id_organization = [];
      if (this.listDataExport.length < 1){
        this.$toast.add({
          severity: 'error',
          summary: 'Thông báo',
          detail: 'Không tồn tại dữ liệu xuất',
          life: 3000
        });
        return false;
      }
      this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      for (var i=0;i<this.listDataExport.length;i++){
        list_id_organization.push(this.listDataExport[i].id);
      }
        try {
          var dataResponse = await this.$coreService.callApiPost('/export_excel/list_organization',{list_id_organization:list_id_organization,user_id : this.userID},{})
          var key_s3 = dataResponse.data.data.key_s3;
          var dataResponseDownload = await this.$coreService.callApiDownloadPost('/export_excel/read_file_export',{key_s3:key_s3},{})
          var url = URL.createObjectURL(new Blob([dataResponseDownload.data], {
            type: 'application/vnd.ms-excel'
          }))
          const link = document.createElement('a')
          link.href = url;
          var file_excel = 'BC_DanhSachDonVi_'+moment().tz("Asia/Bangkok").format('DDMMYYYY')+'_'+moment().tz("Asia/Bangkok").format('HHmmss')+'.xlsx';
          link.setAttribute('download', file_excel)
          document.body.appendChild(link)
          link.click()
          this.showConfirmDialog = true;
          this.creenConfirmDialog = 'export_success';

      } catch (err) {
          console.log("err:",err);
          this.showConfirmDialog = true;
          this.creenConfirmDialog = 'export_err';
        }
      this.$store.commit('setLoading', false);
    },
    dang_phat_trien(){
      alert('Đang phát triển');
    },
    redirect_ToHistory(){
      this.$router.push({path: '/admin/history-export'});
    },
    async filterData(payload){
      console.log("assssssssss:",this.filters)
      this.listDataExport = payload.filteredValue;
    },
    exportDataExcel() {
      if (this.exportData.length > 0) {
        this.$store.commit('setDataLoading', {content: 'Đang tải file', icon: true});
        this.$store.commit('setLoading', true);
        var vm = this;
        setTimeout(() => {
          vm.exportExcel();
        }, 2000);
      }
    },
    exportExcel() {
      var dataJson = [];
      for (let index = 0; index < this.exportData.length; index++) {
        var item = this.exportData[index];
        var organization_type_name = (item['organization_type_name'] != undefined && item['organization_type_name'] != null) ? item['organization_type_name']: '';
        dataJson.push({
          'STT': (index + 1),
          'Tên đơn vị*': (item['name'] != undefined && item['name'] != null) ? item['name']: '',
          'Mã số thuế': (item['tax_number'] != undefined && item['tax_number'] != null) ? item['tax_number']: '',
          'Số điện thoại*': (item['phone_number'] != undefined && item['phone_number'] != null) ? item['phone_number']: '',
          'Email': (item['email'] != undefined && item['email'] != null) ? item['email']: '',
          'Tỉnh/thành phố': (item['province_name'] != undefined && item['province_name'] != null) ? item['province_name']: '',
          'Quận/huyện': (item['district_name'] != undefined && item['district_name'] != null) ? item['district_name']: '',
          'Phường/xã': (item['ward_name'] != undefined && item['ward_name'] != null) ? item['ward_name']: '',
          'Địa chỉ': (item['address'] != undefined && item['address'] != null) ? item['address']: '',
          'Loại đơn vị*': (item['unit_type'] != undefined && item['unit_type'] != null) ? item['unit_type']: '',
          'Số lượng đơn vị cấp con': (item['number_of_subunits'] != undefined && item['number_of_subunits'] != null) ? item['number_of_subunits']: '',
          'Số lượng tài khoản': (item['number_account'] != undefined && item['number_account'] != null) ? item['number_account']: '',
          'Loại quan hệ*': organization_type_name,
          'Trạng thái hoạt động*': (item['status'] != undefined && item['status'] != null) ? item['status']: '',
          'Kinh độ': (item['longitude'] != undefined && item['longitude'] != null) ? item['longitude']: '',
          'Vĩ độ': (item['latitude'] != undefined && item['latitude'] != null) ? item['latitude']: '',
          'note': (item['message'] != undefined && item['message'] != null) ? item['message']: '',
        });
      }
      if (dataJson !== null) {
        var d = new Date();
        var fileName = 'DanhSachDonVi_'  + moment(d).format('DDMMYYYY') + '_' + moment(d).format('HHmmss') + '.xlsx';
        var dataSheet = XLSX.utils.json_to_sheet(dataJson) 
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, dataSheet)
        XLSX.writeFile(wb, fileName)
        this.$store.commit('setLoading', false);
      }
    }
  }
}
</script>
<style lang="scss">
.box-filters{ margin: 15px 0;
  .p-formgroup-inline { display: flex;flex-wrap: wrap; align-items: flex-start;
    .p-field{ margin-right: 50px; margin-bottom: 15px;
      &:last-child{margin: 0; position: relative;}
      label{display: block;}
      .p-dropdown, input{width: 230px;}
      .btn-cancel{width: 90px;position: absolute; top: 30px;}
    }
  }
}
.external-link{ cursor: pointer;
  &.black-color {
    span{color: #000;}
  }
  span{color: #199ED8;}
}
.padding-content .pi-external-link {
    padding-left: 5px;
}

.dialog-comfirm-common{
  width: 434px;
  .p-dialog-header{
    padding-bottom: 4px; padding-top: 4px;
  }
  .box_body_popup{
    width: 100%;
    .p_title_1{
      text-align: center;margin-bottom: 0px;
    }
    .p_title_2{
      text-align: center;
    }
    .box_btn{
      text-align: center;
      margin-top: 8px;
    }
    .box_title_suceess{
      margin-bottom: 10px;
      .img_noti{
        width: 20px;
        height: 20px;
      }
      .title_noti{
        font-family: 'Arial Bold', 'Arial'; font-weight: 700; font-style: normal; font-size: 18px; color: #009900;margin-left: 8px
      }
    }
    .box_title_err{
      margin-bottom: 10px;
      .img_noti{
        width: 20px;
        height: 20px;
      }
      .title_noti{
        font-family: 'Arial Bold', 'Arial'; font-weight: 700; font-style: normal; font-size: 18px; color: #FF0000;margin-left: 8px
      }
    }
  }
}
</style>